import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { IsAccountValidGuard } from './base/is-account-valid.guard';
import { LoadServicesGuard } from './base/load-services.guard';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { isPlatformServer } from '@angular/common';
import { SEOService } from '../services/seo.service';
import { ViewerActions } from '@app/client/viewer/actions';
import * as fromViewer from '@app/client/viewer/reducers/viewer.reducer';
import { MacroTaskWrapperService } from '../services/MacroTaskWrapper.service';
import { StatusCodeResponseService } from '../services/status-code-response.service';
@Injectable({
  providedIn: 'root'
})
export class ViewerGuard {
  constructor(
    private store$: Store<fromRoot.State & fromViewer.State>,
    private loadServicesGuard: LoadServicesGuard,
    private isAccountValidGuard: IsAccountValidGuard,
    private macroTaskWrapper: MacroTaskWrapperService,
    private seoService: SEOService,
    private statusCodeResponseService: StatusCodeResponseService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (isPlatformServer(this.platformId)) {
      // this delegate the execution of the guards on the browser side, hence meta won't be generated
      // return null; // by pass the guard delegate to the component on the client side
      return this.loadTransferInternal().pipe(mergeMap((transferInternalLoaded: boolean) => {
        if (transferInternalLoaded) {
          return of(transferInternalLoaded);
        }
      }));
    } else {
      return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => { // maybe app init ?
        if (servicesLoaded) {
          return this.isAccountValidGuard.canActivate().pipe(mergeMap((isAccountValid: boolean) => { // to refactor
            if (isAccountValid) {
              return of(isAccountValid);
            }
          }));
        }
      }));
    }
  }


  loadTransferInternal(): Observable<boolean> {
    const transferLoaded$ = new ReplaySubject<boolean>();
    this.store$.dispatch(ViewerActions.LoadTransferMetas());
    this.store$
      .pipe(
        withLatestFrom(
          this.store$.select(fromViewer.getTransferMetas),
          this.store$.select(fromViewer.getTransferMetasError),
        ),
        distinctUntilChanged(),
        takeUntil(transferLoaded$),
      )
      .subscribe(([store, transferMetas, error]) => {
        this.macroTaskWrapper.awaitMacroTasks("transferSdk.getTransferInternal");
        this.macroTaskWrapper.awaitMacroTasks("linkSdk.getTarget");
        if (transferMetas) {
          this.seoService.setMetasViewer(transferMetas);
          transferLoaded$.next(true);
        }

        if (error) {
          if (error === 404) {
            this.statusCodeResponseService.setNotFound();
          }
          if (error === 403) {
            this.statusCodeResponseService.setForbidden();
          }
          if (error === 401) {
            this.statusCodeResponseService.setNotAuthorized();
          }
          transferLoaded$.next(true);
        }


      });
    return transferLoaded$.asObservable();
  }
}
